export default __webpack_public_path__ + "static/media/buySearchItems.79583bfc.png";